import {BottomBox, Button, Large, Light, Page, PoweredBy, VBox} from '@bakkt/components'
import {hideDialog, showDialog} from 'components/Dialog'
import PlaidBankLink from './bank/PlaidBankLink'
import {returnToPartner} from 'utils/returnToPartner'
import {useStore} from 'store'
import {ApiPendingBankAccountVerificationTypeEnum, BasicPartyInfoLevelEnum} from '@bakkt/api'
import {embeddedBankLinkingApi} from 'api'
import {useEffect, useState} from 'react'
import {showErrorDialog} from 'components/ErrorDialog'
import {useLocation} from 'react-router-dom'
import {Progress} from '@bakkt/components'

export default () => {
	const {partner, party, fundingAccounts} = useStore()
	const [showTC, setShowTC] = useState(true)
	const [hideLanding, setHideLanding] = useState(false)
	const [displayProgress, setDisplayProgress] = useState(false)
	const location = useLocation()
	if (partner) {
		localStorage.setItem('savedPartner', JSON.stringify(partner))
	}

	const showLinkDialog = (pending: boolean) => {
		showDialog({
			title: `Loading...`,
			WrappedComponent: () => (
				setHideLanding(true),
					<PlaidBankLink
						callBackSuccess={(bankStatus: string) => {
							setHideLanding(true)
							setDisplayProgress(true)
							if (bankStatus === 'pending' || bankStatus === 'pending-auto') {
								returnToPartner(false, null, partner, null, '', bankStatus)
							} else {
								returnToPartner(false, null, partner)
							}
							hideDialog()
							setTimeout(() => setHideLanding(false), 2000)
							// Below line fixes page scroll after plaid linking
							document.body.style.overflow = 'auto'
						}}
						onPlaidExit={() => {
							returnToPartner(true, 'user_cancelled', partner)
							hideDialog()
							// Below line fixes page scroll after plaid linking
							document.body.style.overflow = 'auto'
						}}
						pendingAccount={pending}
					/>
			),
			hideSave: true,
			hideCancel: true,
		})
	}

	const handleBankLinking = async () => {
		setShowTC(false)
		const activeBankAccount = fundingAccounts.find(
			acc => acc.accountType != 'CASH' && acc.accountType !== 'DEBIT' && acc.status === 'ACTIVE',
		)

		if (
			[BasicPartyInfoLevelEnum.LEVEL_1, BasicPartyInfoLevelEnum.LEVEL_1_LIQUIDATED].includes(
				party?.level || BasicPartyInfoLevelEnum.CLOSED,
			)
		) {
			showErrorDialog({
				title: `Contact Customer Support`,
				partner,
				message: 'Your account need status update to complete this task.',
			})
			return
		} else if (activeBankAccount) {
			const institutionName =
				activeBankAccount?.name && activeBankAccount?.name !== 'N/A' ? ` at ${activeBankAccount?.name}` : ''

			const accountNumber = activeBankAccount?.formattedAccountNumber?.match(/\d{4}/)
			showErrorDialog({
				title: `Linked Account already exists`,
				message: `You already have linked account ends with ${accountNumber}${institutionName}.`,
				partner,
				errorCode: 'linked_account_already_exists',
			})
			return
		} else {
			const response = await embeddedBankLinkingApi.getPendingBankAccounts()
			console.log('response', response)
			const pendingBankAccount = response?.data?.payload?.find(ac => true)
			if (
				pendingBankAccount?.verificationStatus! === 'PENDING' &&
				pendingBankAccount?.verificationType != ApiPendingBankAccountVerificationTypeEnum.SAME_DAY_MICRODEPOSIT
			) {
				showErrorDialog({
					title: `Pending Bank Account`,
					message: `Your ${pendingBankAccount?.institutionName} account ending with ${pendingBankAccount?.mask} is pending verification.`,
					partner,
					errorCode: 'account_has_pending_verification',
				})
			} else if (
				pendingBankAccount?.verificationStatus === 'PENDING' &&
				pendingBankAccount?.verificationType == ApiPendingBankAccountVerificationTypeEnum.SAME_DAY_MICRODEPOSIT
			) {
				showLinkDialog(pendingBankAccount?.verificationStatus! === 'PENDING')
			} else {
				showLinkDialog(pendingBankAccount?.verificationStatus! === 'PENDING')
			}
		}
	}
	useEffect(() => {
		console.log('webhook location', location, window.location)
		if (window.location.href.indexOf('webhook') >= 0) {
			showLinkDialog(false)
		}
	}, [location])

	if (hideLanding && displayProgress) {
		return <Progress title='' />
	} else if (hideLanding && !displayProgress) {
		return <div />
	}
	if (!showTC) {
		return <div />
	}

	//TODO replace with Globe icon
	return (
		<Page withSubHeaderLogo={false} showJointLogo={false}>
			<VBox style={{paddingTop: '0', paddingLeft: '15px', paddingRight: '15px'}}>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					xmlSpace='preserve'
					id='prefix__Layer_1'
					x={0}
					y={0}
					viewBox='0 0 361 150'
				>
					<style>{'.prefix__st0{fill:#aadb05}'}</style>
					<path
						d='M132.1 64.7c7 0 12.7-5.7 12.7-12.7 0-7-5.7-12.7-12.7-12.7-7 0-12.7 5.7-12.7 12.7-.1 7 5.6 12.7 12.7 12.7zM139 70.3l18.3 43.8L184 66.5l-45 3.8z'
						className='prefix__st0'
					/>
					<path
						d='M360.6 112c-8.4 3.9-58 26.4-97.7 24.8-10.3-.4-26.1-1.3-38.5-12.6-4.6-4.2-7.5-8.6-9.2-11.8-5.2-10.6-1.1-17.5-7.5-23.2-3.4-3.1-10-6.5-13.8-4.3-1.2.7-2.7 2.3-2.4 3.2.3.8 2.4 1 3.9.4 1.8-.6 3.1-2.4 3.5-3.9 1.1-4.1-3.9-6.5-6.7-13-2.7-6.4-2.5-15 .7-16.6 3.4-1.6 10.9 4.1 10.3 7.9-.4 2.3-3.2 2.8-3.2 5.4 0 2.1 2 3.7 3.8 4.7 1.5.8 2.7.5 3.2-.4.5-.8.3-2.2 0-3.3-.3-1.1-.6-2.1-.5-2.9.1-.8.7-1.4 1.6-1.8.9-.3 2.1-.3 3-.1.9.3 1.6.8 2.3.8.6 0 1.3-.5 1.9-.6.8-.1 1.4.7 1.7 1 1.9 2.2.8 10.1 2.5 14.8 2.3 6.3 8.7 4.4 11.1 10 3.9 9-9.4 23.4-5.4 27.4.9.9 4.1 2.7 3.7 4.2-.3 1.7-1.2 2.9-1.6 3.5-1.5 2.5-4.4 6.3-7.6 9.5-3.2 3.2-6.9 5.6-10.4 7.4-3.5 1.8-6.9 2.9-11 3.4-4.1.6-8.9.6-12-.1-3.1-.7-4.6-2.1-5.3-3.6-.7-1.5-.6-3.1-.4-4.5.2-1.4.3-2.8-.2-4.1-.6-1.3-2-2.6-3.5-4.2s-3.2-3.5-4.1-5.6c-.9-2.2-1-4.6-.4-6.5.5-1.9 1.7-3.2 2-5 .3-1.8-.4-4.1.2-6 .5-1.9 2.3-3.5 2.8-5s-.2-2.9-1.2-3c-1-.1-2.3 1.1-2.6 2.6-.3 1.5.4 3.5 1.7 4.8 1.3 1.3 3.2 2 5.1 2.3 1.9.3 3.8.2 5.1.2 1.3 0 1.9.1 3.1.9 1.1.8 2.6 2.4 4 3.1 1.4.8 2.7.7 4.4.4 1.6-.3 3.6-.8 5.4-.5 1.8.2 3.3 1.1 4.2 2.5.8 1.3 1 3.1.8 4.7-.2 1.6-.6 3.1-1.5 4.3-.8 1.2-2 2.2-3.5 3-1.5.8-3.3 1.4-4.7 2.6-1.4 1.1-2.3 2.8-2.6 4.3s.2 2.7-.4 4.1c-.5 1.4-2.1 3-2.6 4.2-.5 1.2.1 2 1.4 2.7 1.3.6 3.3 1.1 4.3 1.3 1 .2 1 .2 0 .7-1 .5-3.1 1.6-6.5 2-3.4.5-8.1.3-13.1-.6-5-.9-10.2-2.5-15.4-5.5-5.1-3-10.1-7.2-13.8-11.8-3.7-4.5-6.1-9.2-7.8-14.5-1.8-5.3-2.8-11.2-2.7-16.8.2-5.6 1.6-10.9 3-14.5 1.4-3.6 2.8-5.5 4.3-6.9 1.5-1.4 3.2-2.4 4.9-4.2 1.6-1.8 3.3-4.4 5-6.3 1.7-1.9 3.5-3 5.8-3.7 2.3-.6 5.2-.8 6.9-2.2 1.8-1.4 2.6-4 3.9-5.1 1.3-1.1 3.2-.5 5.1.2 1.9.8 3.7 1.8 4.6 2.9.9 1.1.9 2.1.6 3.9-.3 1.7-.9 4-2.2 5.8-1.3 1.9-3.3 3.4-4.7 3.9-1.4.6-2.1.3-2.3-.1-.2-.4.2-.9 1-1.4.8-.5 1.9-1.1 3.2-1.1 1.3 0 2.7.5 3.8 1.4 1.1 1 1.9 2.4 1.9 3.5s-.9 1.8-2.6 2.9c-1.7 1.1-4.3 2.4-6.4 4.1-2.1 1.7-3.6 3.7-4.7 5.5-1.1 1.8-1.8 3.5-2.3 5.2-.5 1.6-.6 3.2-.4 4.2.2 1 .8 1.3 1.4 1.2.6-.2 1.3-.8 1.4-1.8.2-1-.2-2.5-1-3.7-.8-1.3-2.2-2.3-4.1-2.7s-4.5-.2-6.4.5c-1.9.8-3.1 2.1-3.6 3.2s-.4 1.9.3 2.3c.7.4 1.9.4 3.1.4 1.2 0 2.3 0 3.3.2 1 .3 1.9.8 2.2 1.7.3.9.1 2.2-.2 3.3-.3 1.1-.5 2-.4 2.9.1.9.6 1.8 1.5 2.8.9 1 2.1 2.1 2.8 2.9.6.8.7 1.3.5 1.9-.2.6-.7 1.4-2 1.8s-3.4.6-5.3.3-3.7-1.2-5-2c-1.2-.8-1.9-1.6-2.4-2.6s-.7-2.1-1.3-2.9c-.6-.8-1.6-1.3-2.7-1.9-1.1-.5-2.4-1.1-3.4-2.3-1-1.1-1.8-2.9-2.1-3.9-.4-1-.4-1.3-.3-1.7.1-.4.4-1 .2-2.1s-.6-2.6-.9-4.3c-.2-1.7-.2-3.7.1-6 .3-2.3.8-5.1 2-7.8s3-5.4 5.3-8.1c2.3-2.7 5-5.3 8.1-7.5 3-2.2 6.2-4 9.4-5.4 3.2-1.4 6.4-2.4 10.2-3.1 3.9-.7 8.4-1.1 13.6-.5 8.3.9 15.4 4.2 16.4 4.7 2.5 1.2 8.2 3.9 13.7 9.4 12.1 11.9 13.5 27 13.7 29.8.7 9-1.3 16.4-3.1 21 10.5-10.6 15.8-22.7 14.9-31.7-.3-3-.8-8.3-4.6-12.6-1.1-1.2-3-3.1-5.4-4.8-3.4-2.4-6.3-3.4-7.9-6.7-.1-.2-.4-1-.7-2-.6-2.7 0-5 .6-7.1.5-1.6 1.1-3.2 1.4-3.9.3-.6.3-.8.5-1.1 0 0 .1-.3 1.1 0s3.1 1.1 5.4 2.3c2.1 1.1 3.6 2.1 6.6 4.1 1.4 1 2.5 1.8 3.3 2.3-1.6 5.1-5.2 8.5-9 8.5-1.4 0-3.5-.5-5.2-2.1-2.1-2-2.2-4.7-2.2-5.5-.1-2.7.8-4.7 1.8-6.9 0 0 0-.1.1-.1.6.2 1.1.5 1.7.7.1-.2.7-1.3.9-1.6 1.8-3.2 2.7-4.8 3.7-5.3 1.3-.6 3.1-.3 4.2.5.3.2 1.6 1.1 1.8 2.6.2 1.3-.6 2.9-2.2 6-.3.5-1.8 2.5-1.9 2.8 1 .6 1.9 1.3 2.9 1.9.7-1.2 2.9-4.6 3.7-6.8.8-2.3 1.3-3.4 1.1-4.6-.5-3.7-5-5.6-5.4-5.8-.7-.3-1.5-.6-2.6-.6-4.5 0-7.4 5.8-7.6 6.2-1-.5-2.2-1-3.5-1.4-1.7-.5-3.3-.8-4.7-1-3.8 5-4.4 11.8-1.5 17.3 3.4 6.4 10.5 8.8 15.9 8.4 1.4-.1 4.6-.6 7.8-2.8 7-5 9.5-15.5 5.8-22.9-2.1-4.1-5.6-6.2-7.1-6.9-10-5.2-19.4 2.2-30.1-1-5.7-1.7-9.8-5.3-9.8-5.3-.9-.8-1.5-1.4-1.9-1.9.8-1.7 1.9-4.7 2-8.5 0-1.6.1-6.3-2.9-11-4.7-7.3-13-8.4-13.7-8.4-6.5-.7-13.7 1.9-17.7 8-3.7 5.7-2.9 11.8-2.7 13.3 4.4-2.8 8.9-5.6 13.3-8.4l4.2 5.4c3.2-2.2 6.3-4.4 9.5-6.6-1.2-.2-2.4-.5-3.6-.7.1-1 .3-1.9.4-2.9 2.9.5 5.7 1 8.6 1.5-.5 2.8-1 5.6-1.4 8.5-.9-.1-1.8-.2-2.8-.3.2-1.3.3-2.5.5-3.8-3.9 2.8-7.8 5.7-11.7 8.5-1.4-1.8-2.9-3.5-4.3-5.3-3.8 2.6-7.6 5.1-11.3 7.7.5 1.5 1.5 3.7 3.5 6 .8 1 3.4 3.7 7.8 5.2 4.9 1.7 9.1.8 10.2.5 5.4-1.3 8.5-4.7 9.6-5.9-.4-.2-.9-.5-1.5-.8-.5-.2-1.7-.8-3.2-1.4-1.4-.5-3.1-1-5-1.3-4-.7-9.3-.8-14.6.6-5.2 1.4-10.4 4.2-14.5 9s-7.2 11.7-10.5 17.2c-2.9 4.8-6 8.6-9.7 11.1-.7.5-7.6 4.7-15.5 1.6-.8-.3-8.2-3.3-10.3-11.3-1.6-5.8-.2-13.4 5.9-17.6 5.6-4 13.7-3.8 19 .8 4.4 3.8 6.4 10 4.6 15.9-1.6 5.3-6.6 9.8-12.1 10.9-.8-2.3-1.7-4.5-2.5-6.7-.7 0-2.4-.2-4.1-1.4-.4-.3-1.9-1.4-2.8-3.5-.3-.7-.9-2.4-.5-4.4.2-1.3.8-2.4 1.2-3.1.3-.5.8-.9.8-.9l.5-.5c-.4-1.1-.8-2.1-1.2-3.2 1-.3 1.9-.6 2.9-.9.3.8.7 1.9 1.1 3.2 1.8 5.3 2.4 7.4 3.9 11.3.5 1.2 1.1 3 2 5.2 1.1-.4 2.2-.8 3.2-1.2-.3-.8-.7-1.7-1.1-2.5.5-.3 1.2-1 1.8-1.9.6-1 .8-1.9.8-2.1.2-1 0-1.9-.1-2.4-.9.3-1.7.5-2.6.8 0 .5 0 1.3-.5 2.2-.6 1.2-1.6 1.8-2.1 2-.3.2-1.6.8-3.4.6-1.2-.1-2.3-.5-3.1-1.4-.8-.9-1.4-2.3-1.6-3.5-.1-1.3.2-2.4.9-3.3.3-.4 1-1.5 2.5-2.1.4-.2 2-.8 3.7 0 .7.3 1.2.7 1.5 1 1-.4 2.1-.7 3.1-1.1 0-.1-.1-.2-.2-.3-.1-.2-.8-1.2-1.8-1.8-1.4-.9-2.9-.8-3.4-.7-.6-1.1-1.8-2.7-3.3-4.4-13-14.5-35.9-13.4-43.7-13.1C53.7 27.7 27.4 50.5.3 65.7'
						style={{
							fill: 'none',
							stroke: '#000',
							strokeWidth: 1.5262,
							strokeMiterlimit: 10,
						}}
					/>
				</svg>
				<Large style={{fontFamily: '', fontSize: '28px', margin: '51px 15px 10px 15px', textAlign: 'center'}}>
					Webull Pay partners with Bakkt to provide ACH options.
				</Large>
				<Large style={{fontFamily: '', fontSize: '20px', margin: '10px 15px 1px 15px', textAlign: 'center'}}>
					You're on your way to connecting your bank account.
				</Large>
			</VBox>
			<Light style={{paddingTop: '0', marginBottom: '2em', placeSelf: 'center'}}>
				<PoweredBy />
			</Light>
			<BottomBox style={{marginTop: '50px', marginBottom: '10px'}}>
				<VBox verticalGap={10} style={{width: '-webkit-fill-available'}}>
					<Button size='large' onClick={handleBankLinking}>
						Continue
					</Button>
				</VBox>
			</BottomBox>
		</Page>
	)
}
